var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexPage"},[_c('div',{staticClass:"content_area"},[_c('div',{staticClass:"mainVideo"},[_c('AliyunVideo',{staticClass:"mainVideoContent",attrs:{"AliyunId":_vm.mainVideoId,"autoplay":false}})],1)]),_c('setTalkDialog',{ref:"setTalk"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }